import { Col, Row } from "react-bootstrap"
import AccountSmallPreview from "src/components/AccountSmallPreview/AccountSmallPreview"

export function AccountPanel({ account, funnelData }) {
  return (
    <div>
      <Row className='mt-3'>
        <Col md={12}>
          <AccountSmallPreview
            account={funnelData.account}
            showAccountBtn={account === null}
          />
        </Col>
      </Row>
    </div>
  )
}
